module.exports = __webpack_public_path__ + "faq/img/medal.e20f067c.png";